<template>
  <v-app>
    <!-- Thanh AppBar -->
    <v-app-bar v-if="!isLoginPage" color="primary" prominent>
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Hệ thống quản lý người dùng</v-toolbar-title>
    </v-app-bar>

    <!-- Menu xổ từ trái -->
    <v-navigation-drawer v-model="drawer" location="left" temporary>
      <v-list>
        

        <router-link v-for="(item, index) in menuItems" :key="index" :to="item.route" class="custom-link">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>

        <v-list-item @click="logout">
          <v-list-item-content>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<style scoped>
.custom-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  padding: 5px;
  transition: background 0.3s ease-in-out;
}

.custom-link:hover {
  background: rgba(0, 0, 0, 0.1);
}

.v-list-item-content {
  display: flex;
  align-items: center;
}
</style>

<script>
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    menuItems: [
      { title: "Quản lý người dùng", route: "/quan-ly-nguoi-dung" },
      { title: "Quản lý công ty", route: "/quan-ly-cong-ty" },
      { title: "Quản lý Projects", route: "/quan-ly-projects" },
      { title: "Quản lý Modules", route: "/quan-ly-modules" },
      { title: "Quản lý Roles", route: "/quan-ly-roles" },
      { title: "Phân quyền người dùng", route: "/phan-quyen-user" },
      { title: "Quên mật khẩu", route: "/quen-mat-khau" },
      { title: "Reset Password", route: "/reset-password" },
    ],
  }),
  computed: {
    isLoginPage() {
      return this.$route.path === "/login" || this.$route.path === "/quen-mat-khau" || this.$route.path === "/reset-password" || this.$route.path === "/user-info";
    }
  },
  mounted() {
    document.title = "Hệ thống quản lý người dùng";
  },
  methods: {
    logout() {
      this.$cookies.remove("auth");
      this.$router.push("/login");
    }
  }
};
</script>
